export default {
    name: 'v5-icon-praise',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M757.76 852.907c36.907-.022 72.832-30.208 79.296-66.56l51.093-287.04c10.07-56.47-27.093-100.523-84.373-100.096l-10.261.085a19972.267 19972.267 0 01-52.843.363 3552.853 3552.853 0 01-56.747 0l-30.997-.427 11.499-28.8c10.24-25.643 21.76-95.744 21.504-128.021-.619-73.046-31.36-114.859-69.291-114.411-46.613.555-69.461 23.467-69.333 91.136.213 112.661-102.144 226.112-225.131 225.11a1214.08 1214.08 0 00-20.63 0l-3.52.042c-.191 0 .64 409.11.64 409.11 0-.086 459.094-.491 459.094-.491zm-17.301-495.915a15332.288 15332.288 0 0052.693-.363l10.283-.085c84.01-.619 141.44 67.52 126.72 150.25l-51.094 287.02c-10.09 56.66-63.68 101.695-121.258 101.76l-458.923.383a42.667 42.667 0 01-42.88-42.41l-.853-409.174a42.624 42.624 0 0142.346-42.73l3.67-.043c5.909-.064 13.12-.064 21.333 0 98.176.79 182.293-92.437 182.144-182.379-.17-91.2 41.6-133.034 111.467-133.888 65.173-.768 111.68 62.507 112.448 156.715.256 28.48-6.848 78.827-15.702 115.05 8.022 0 17.28-.042 27.584-.106zM170.667 448v405.333h23.466a21.333 21.333 0 010 42.667h-39.296A26.71 26.71 0 01128 869.333V432c0-14.784 12.075-26.667 26.773-26.667h38.912a21.333 21.333 0 010 42.667h-23.018z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
